import util from "@/util/util";
export default {
    // 导出excel,name可为空，如果指定name，需要指定文件类型
    exportExcel(url, params, name) {
        return new Promise(resolve => {
            // 把参数转成params
            let query = "";
            for (let key in params) {
                // 0 是有效值（如状态=下架、是否云客户=否），不能用 truthy 判断
                const value = params[key];
                if (value !== "" && value !== null && value !== undefined) {
                    query += "&" + key + "=" + encodeURIComponent(value);
                }
            }
            query = query.replace("&", "");
            let token = util.getHeaderToken();
            const link = document.createElement("a");
            link.style.display = "none";
            if (!url.startsWith("http")) {
                url = `${process.env.VUE_APP_BASE_URL}${url}`;
            }
            link.href = `${url}?${query}&token=${token}`;
            if (name) {
                link.setAttribute("download", name);
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            resolve();
        });

    },
}